import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy text-white/80 py-6 px-4 border-t-4 border-brand-yellow" data-id="element-75">
      <div className="max-w-3xl mx-auto text-center" data-id="element-76">
        <div className="inline-block bg-brand-yellow text-brand-navy font-display font-bold px-4 py-1.5 rounded-md uppercase text-xs tracking-widest mb-3" data-id="element-77">
          Sistema Acuicultura Pro™
        </div>
        <p className="text-xs md:text-sm font-medium mb-2 leading-snug" data-id="element-78">
          Material desarrollado por técnicos y docentes del sector acuícola para
          técnicos y docentes del sector acuícola.
        </p>
        <p className="text-[11px] md:text-xs text-white/60 leading-snug max-w-2xl mx-auto mb-3" data-id="element-79">
          El precio está expresado en dólares estadounidenses (USD). El cobro se
          realiza automáticamente en la moneda de tu país al tipo de cambio del
          momento de la compra.
        </p>
        <p className="text-[11px] md:text-xs font-bold uppercase tracking-widest border-t border-white/10 pt-3" data-id="element-80">
          © 2025 Sistema Acuicultura Pro™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}